import { jsxs as n, jsx as r } from "react/jsx-runtime";
import a from "../../utils/colors.js";
import e from "../Icons/CircleTick.js";
import { ThumbDownIcon as c } from "../Icons/ThumbDown.js";
import { ThumbUpIcon as u } from "../Icons/ThumbUp.js";
import h from "../Text/index.js";
import { ThumbWrapper as l, CircleTickWrapper as s } from "./styled.js";
const g = ({
  direction: p = "up",
  onClick: t,
  disabled: m = !1,
  selected: o = !1,
  feedbackText: i,
  ...f
}) => /* @__PURE__ */ n(
  l,
  {
    type: "button",
    onClick: t,
    $disabledStyle: m,
    selected: o,
    ...f,
    children: [
      o && /* @__PURE__ */ r(s, { children: /* @__PURE__ */ r(e, { fill: a.orange }) }),
      p === "up" ? /* @__PURE__ */ r(u, { selected: o, disabled: m }) : /* @__PURE__ */ r(c, { selected: o, disabled: m }),
      /* @__PURE__ */ r(h.Body, { $fontWeight: 500, as: "span", children: i })
    ]
  }
);
export {
  g as default
};
